/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {createAccountHolderInternal} from '../api'

export const useMutationCreateAccountHolderInternal = createReactQueryMutationHook('createAccountHolderInternal', createAccountHolderInternal)
